import _ from 'lodash'
import { generateGameConfigResource } from '@/store/creative/common'

/**
 * addGameDifficulty 添加游戏配置难度模式
 * @param {any} state
 * @param {{tag: string, category: {name: string, prefix: string, id: number, resource_type: string}}} param1
 */
export async function addGameDifficulty(
  { state, dispatch, commit },
  { tag, category },
) {
  const gameDifficultyList = _.cloneDeep(
    state.gameConfigResource.gameDifficultyList,
  )

  if (gameDifficultyList.some((item) => item.tag === tag)) {
    console.warn('已有该难度')
    return
  }

  const gameConfigKeysInsideGameConfigTab = Object.keys(
    gameDifficultyList.find((item) => !_.isEmpty(item.data)).data,
  )

  const newGameConfig = {
    ...generateGameConfigResource({
      // 提取在玩法 tab 下的玩法
      data: _.pick(
        state.originalJson.gameConfig,
        gameConfigKeysInsideGameConfigTab,
      ), // 游戏配置/object
      category_id: category.id,
      name: category.name,
      prefix: category.prefix, // multiGameDifficulty
    }),
    tag: tag,
    is_default: true,
  }
  gameDifficultyList.push(newGameConfig)

  // 更新 gameConfig
  state.gameConfigResource.gameDifficultyList = gameDifficultyList

  // 更新 groups config，保证新增后 groups config 也联动更新
  await dispatch('updateGroupsConfig')
}

/**
 * removeGameDifficulty
 * @param {any} state
 * @param {{tag: string}} param1
 */
export async function removeGameDifficulty(
  { state, dispatch, commit },
  { tag },
) {
  state.gameConfigResource.gameDifficultyList =
    state.gameConfigResource.gameDifficultyList.filter(
      (item) => item.tag !== tag,
    )
  // 更新 groups config，保证删除后 groups config 也联动更新
  await dispatch('updateGroupsConfig')
}
